import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, OnInit, TemplateRef } from '@angular/core';
import { AbstractControl, FormBuilder, ValidationErrors, Validators } from '@angular/forms';
import { UserManagementService } from '../user-management/user-management.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { ChatpopupComponent } from 'src/app/components/chatpopup/chatpopup.component';
import { SiteService } from 'src/app/site/site.service';
import { MessageService } from 'primeng/api';
import { AlertsService } from 'src/app/alerts/alerts.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    standalone: false
})
export class HeaderComponent implements OnInit, AfterViewInit {
  public isCollapsed = false;
  public isMenuCollapsed = true;
  public selectedSite = '';
  public sitesList: any[] = [];
  public currentUser: any = null;
  public resetPasswordForm;
  public resetPasswordUsers: any[] = [];
  public selectedResetUser: any = null;
  public resetUsersLoading = false;
  public resetPasswordSubmitting = false;
  public showResetPassword = false;
  isAnyMenuOpen = false;
  private resetPasswordModalRef: NgbModalRef | null = null;
  private openDropdowns = new Map<NgbDropdown, HTMLElement>();

  constructor(
    private userService: UserManagementService,
    private modalserivce: NgbModal,
    private siteService: SiteService,
    private messageService: MessageService,
    private fb: FormBuilder,
    private alertsService: AlertsService
  ) {
    this.resetPasswordForm = this.createResetPasswordForm();
  }

  ngOnInit(): void {
    this.currentUser = this.userService.getUserDetail();
    this.onSiteAdded();
  }
  ngAfterViewInit() {
    this.getSiteList();
  }

  getSiteList() {
    const siteList = this.userService.getSiteDetail();
    if (siteList && siteList.length) {
      this.sitesList = siteList;
      const userDetail = this.userService.getUserDetail();
      if (userDetail && userDetail.role == 1 && this.sitesList && this.sitesList.length) {
        setTimeout(() => {
          this.selectedSite = this.sitesList[0].site_id;
          this.onSiteChange(this.selectedSite);
        })
      }
    }
  }

  onSiteChange(event) {
    this.userService.updateMessage({ 'purpose': 'sitechanged', 'value': event });
    this.userService.selectedSite = this.selectedSite;
  }

  onSiteAdded() {
    this.userService.getMessage().subscribe(data => {
      if (data.purpose === 'siteadded') {
        this.sitesList = data.value;
        if (this.sitesList && this.sitesList.length) {
          const allSiteIds = this.sitesList.map(ele => ele.site_id);
          if (!allSiteIds.includes(this.selectedSite)) {
            this.selectedSite = '';
            setTimeout(() => {
              this.selectedSite = allSiteIds[0];
              this.userService.selectedSite = String(this.selectedSite);
            });
          } else {
            this.selectedSite = '';
            setTimeout(() => this.selectedSite = String(this.userService.selectedSite));
          }
        }
      }
    });
  }
  onChange() {
    this.selectedSite = null;
    this.selectedSite = this.userService.selectedSite;
  }
  aiPopShow(data) {
    const modalRef = this.modalserivce.open(ChatpopupComponent,{
      size : 'l',
      backdrop: 'static',
      backdropClass: 'my-custom-class glassmorphic-backdrop',
    });
    modalRef.componentInstance.src = data;
    modalRef.componentInstance.event = event;
    setTimeout(() => {
      const modalElement = document.querySelector('.modal');
      if (modalElement) {
        (modalElement as HTMLElement).style.zIndex = '1100';
      }
    }, 0);
  }
  logout() {
    console.log('🚪 Logout method called');
    
    // Clear filter selections before logout
    this.clearAllFilterSelections();
    
    this.userService.logout();
    sessionStorage.removeItem('visitedUserManagementSites');
    sessionStorage.removeItem('admin_id');
    
    console.log('✅ Logout completed');
  }

  openDropdownOnHover(dropdown: NgbDropdown, event: MouseEvent): void {
    const host = event.currentTarget as HTMLElement | null;
    if (!host) {
      return;
    }

    this.closeUnrelatedDropdowns(host);
    dropdown.open();
    this.openDropdowns.set(dropdown, host);
    this.syncMenuBackdrop();
  }

  closeDropdownOnLeave(dropdown: NgbDropdown, event: MouseEvent): void {
    const host =
      this.openDropdowns.get(dropdown) ??
      (event.currentTarget as HTMLElement | null);
    const nextTarget = event.relatedTarget as Node | null;

    if (host && nextTarget && host.contains(nextTarget)) {
      return;
    }

    this.closeDropdownBranch(host, dropdown);
  }

  onDropdownOpenChange(dropdown: NgbDropdown, isOpen: boolean): void {
    const host = this.openDropdowns.get(dropdown);

    if (isOpen && host) {
      this.openDropdowns.set(dropdown, host);
    } else {
      this.openDropdowns.delete(dropdown);
    }

    this.syncMenuBackdrop();
  }

  closeAllDropdowns(): void {
    this.openDropdowns.forEach((_, dropdown) => dropdown.close());
    this.openDropdowns.clear();
    this.syncMenuBackdrop();
  }

  // Test method - you can call this from browser console to test localStorage clearing
  public testClearFilters(): void {
    console.log('🧪 Testing filter cleanup...');
    this.clearAllFilterSelections();
  }

  // Test method - creates test filter data to verify clearing works
  public createTestFilterData(): void {
    console.log('🧪 Creating test filter data...');
    localStorage.setItem('reportFilter_2_51', '1');
    localStorage.setItem('reportFilter_12_30', '5');
    localStorage.setItem('reportFilter_6_25', '3');
    localStorage.setItem('test_other_data', 'some_value');
    console.log('✅ Test filter data created. Now try testClearFilters()');
  }

  // Simple method to check current localStorage state
  public checkLocalStorage(): void {
    console.log('📊 Current localStorage state:');
    console.log('Total items:', localStorage.length);
    console.log('All keys:', Object.keys(localStorage));
    console.log('Filter keys:', Object.keys(localStorage).filter(key => key.startsWith('reportFilter_')));
  }

  // Force clear all filter data (nuclear option)
  public forceClearFilters(): void {
    console.log('💥 Force clearing all filter data...');
    const allKeys = Object.keys(localStorage);
    const filterKeys = allKeys.filter(key => key.startsWith('reportFilter_'));
    
    filterKeys.forEach(key => {
      localStorage.removeItem(key);
      console.log(`💥 Force removed: ${key}`);
    });
    
    console.log(`💥 Force cleared ${filterKeys.length} filter keys`);
    this.checkLocalStorage();
  }

  private clearAllFilterSelections(): void {
    try {
      console.log('🔍 Starting filter cleanup...');
      console.log('📊 Total localStorage items:', localStorage.length);
      
      // Method 1: Using Object.keys (more reliable)
      const allKeys = Object.keys(localStorage);
      console.log('📋 All localStorage keys (Object.keys):', allKeys);
      
      const filterKeys = allKeys.filter(key => key.startsWith('reportFilter_'));
      console.log('🎯 Filter keys found:', filterKeys);
      
      // Method 2: Using traditional loop
      const keysToRemove: string[] = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith('reportFilter_')) {
          keysToRemove.push(key);
        }
      }
      console.log('🎯 Filter keys found (loop method):', keysToRemove);
      
      // Clear using both methods for redundancy
      const allFilterKeys = [...new Set([...filterKeys, ...keysToRemove])];
      console.log('🗑️ All unique filter keys to remove:', allFilterKeys);
      
      allFilterKeys.forEach(key => {
        const value = localStorage.getItem(key);
        console.log(`Removing key: ${key} with value: ${value}`);
        localStorage.removeItem(key);
        console.log(`✅ Cleared filter selection for key: ${key}`);
      });
      
      console.log(`🎉 Manual logout cleanup: Cleared ${allFilterKeys.length} filter selections`);
      
      // Verify removal
      const remainingKeys = Object.keys(localStorage).filter(key => key.startsWith('reportFilter_'));
      console.log('🔍 Remaining filter keys after cleanup:', remainingKeys);
      
      if (remainingKeys.length > 0) {
        console.warn('⚠️ Some filter keys still remain! Trying alternative method...');
        // Alternative method - clear all localStorage and restore non-filter items
        this.clearAllAndRestore();
      }
      
    } catch (e) {
      console.error('❌ Error clearing filter selections during manual logout:', e);
    }
  }

  private closeUnrelatedDropdowns(currentHost: HTMLElement): void {
    Array.from(this.openDropdowns.entries()).forEach(([dropdown, host]) => {
      const isRelated =
        host === currentHost ||
        host.contains(currentHost) ||
        currentHost.contains(host);

      if (!isRelated) {
        dropdown.close();
        this.openDropdowns.delete(dropdown);
      }
    });
  }

  private closeDropdownBranch(
    host: HTMLElement | null,
    fallbackDropdown?: NgbDropdown
  ): void {
    if (!host) {
      if (fallbackDropdown) {
        fallbackDropdown.close();
        this.openDropdowns.delete(fallbackDropdown);
        this.syncMenuBackdrop();
      }
      return;
    }

    Array.from(this.openDropdowns.entries()).forEach(([dropdown, dropdownHost]) => {
      if (dropdownHost === host || host.contains(dropdownHost)) {
        dropdown.close();
        this.openDropdowns.delete(dropdown);
      }
    });

    this.syncMenuBackdrop();
  }

  private syncMenuBackdrop(): void {
    this.isAnyMenuOpen = this.openDropdowns.size > 0;
  }

  private clearAllAndRestore(): void {
    try {
      console.log('🔄 Using alternative clearing method...');
      
      // Get all non-filter keys
      const allKeys = Object.keys(localStorage);
      const nonFilterKeys = allKeys.filter(key => !key.startsWith('reportFilter_'));
      const nonFilterData: { [key: string]: string } = {};
      
      // Store non-filter data
      nonFilterKeys.forEach(key => {
        nonFilterData[key] = localStorage.getItem(key) || '';
      });
      
      console.log('💾 Stored non-filter data:', Object.keys(nonFilterData));
      
      // Clear all localStorage
      localStorage.clear();
      console.log('🧹 Cleared all localStorage');
      
      // Restore non-filter data
      Object.entries(nonFilterData).forEach(([key, value]) => {
        localStorage.setItem(key, value);
      });
      
      console.log('🔄 Restored non-filter data');
      console.log('✅ Alternative clearing method completed');
      
    } catch (e) {
      console.error('❌ Error in alternative clearing method:', e);
    }
  }

  openResetPasswordModal(content: TemplateRef<any>) {
    if (!this.isSystemAdmin) {
      return;
    }

    this.resetUsersLoading = true;
    this.resetPasswordSubmitting = false;
    this.showResetPassword = false;
    this.selectedResetUser = null;
    this.resetPasswordUsers = [];
    this.resetPasswordForm.reset();

    this.resetPasswordModalRef = this.modalserivce.open(content, {
      centered: true,
      backdrop: 'static',
      size: 'lg',
      backdropClass: 'reset-password-modal-backdrop',
      windowClass: 'reset-password-modal-window',
    });
    this.resetPasswordModalRef.result.finally(() => this.clearResetPasswordModalState());

    this.alertsService
      .getallusers()
      .subscribe((response: any) => {
        this.resetPasswordUsers = response?.results || [];
      },
      () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Password Reset Failed',
          detail: 'Unable to load users.',
        });
      })
      .add(() => {
        this.resetUsersLoading = false;
      });
  }

  onResetUserChange(userId: string) {
    this.selectedResetUser =
      this.resetPasswordUsers.find(
        (user: any) => String(user.user_id) === String(userId)
      ) || null;
  }

  closeResetPasswordModal() {
    if (this.resetPasswordSubmitting) {
      return;
    }

    this.resetPasswordModalRef?.close();
  }

  submitResetPassword() {
    if (!this.selectedResetUser || this.resetPasswordSubmitting) {
      return;
    }

    if (this.resetPasswordForm.invalid) {
      this.resetPasswordForm.markAllAsTouched();
      return;
    }

    const { newPassword } = this.resetPasswordForm.getRawValue();
    this.resetPasswordSubmitting = true;

    this.siteService
      .adminResetPassword({
        user_id: Number(this.selectedResetUser.user_id),
        new_password: newPassword || '',
      })
      .then((response: any) => {
        if (response?.status === 1) {
          this.messageService.add({
            severity: 'success',
            summary: 'Password Reset',
            detail: 'Password reset successfully. User must log in again.',
          });
          this.resetPasswordModalRef?.close();
          return;
        }

        this.showResetPasswordError(response);
      })
      .catch((error: HttpErrorResponse) => this.showResetPasswordError(error))
      .finally(() => {
        this.resetPasswordSubmitting = false;
      });
  }

  get isSystemAdmin(): boolean {
    const role = this.currentUser?.role ?? this.currentUser?.user_role;
    return String(role) === '1';
  }

  getResetPasswordRoleLabel(user: any): string {
    return user?.role_name || user?.role || user?.user_role || '-';
  }

  private clearResetPasswordModalState() {
    this.resetPasswordModalRef = null;
    this.resetUsersLoading = false;
    this.resetPasswordSubmitting = false;
    this.showResetPassword = false;
    this.selectedResetUser = null;
    this.resetPasswordUsers = [];
    this.resetPasswordForm.reset();
  }

  private createResetPasswordForm() {
    return this.fb.group(
      {
        newPassword: ['', [Validators.required, Validators.minLength(8)]],
        confirmPassword: ['', Validators.required],
      },
      { validators: HeaderComponent.passwordsMatchValidator }
    );
  }

  private static passwordsMatchValidator(group: AbstractControl): ValidationErrors | null {
    const newPassword = group.get('newPassword')?.value;
    const confirmPassword = group.get('confirmPassword')?.value;

    if (!newPassword || !confirmPassword) {
      return null;
    }

    return newPassword === confirmPassword ? null : { passwordMismatch: true };
  }

  private showResetPasswordError(error: any) {
    const status = error?.status ?? error?.error?.status;
    const backendMessage =
      error?.error?.message ||
      error?.error?.msg ||
      error?.message ||
      error?.msg;

    let detail = 'Password reset failed';

    if (status === 401) {
      detail = 'Session expired, please log in again.';
    } else if (status === 403) {
      detail = 'Insufficient permission.';
    } else if (status === 400 || status === 0) {
      detail = backendMessage || 'Password reset failed';
    } else if (backendMessage && error?.status == null) {
      detail = backendMessage;
    }

    this.messageService.add({
      severity: 'error',
      summary: 'Password Reset Failed',
      detail,
    });
  }

}
